export default __webpack_public_path__ + "static/media/edomex-mod.62af76cb.geojson";